export const selectOptionsInterestCalcType = [
  "Actual/360",
  "30/360",
  "Actual/365",
];
